/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_ClosedInputs */

const en_filter_is_closed = /** @type {(inputs: Filter_Is_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`closed`)
};

const de_filter_is_closed = /** @type {(inputs: Filter_Is_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geschlossen`)
};

/**
* | output |
* | --- |
* | "closed" |
*
* @param {Filter_Is_ClosedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_closed = /** @type {((inputs?: Filter_Is_ClosedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_ClosedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_closed(inputs)
	return en_filter_is_closed(inputs)
});